import LangSelector from '@efex-components/navbar/lang';
import { useEffect } from 'react';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';

const Header = () => {
  const { whiteLabelState, getWhiteLabelFromLocalStorage } =
    useWhiteLabelService();

  useEffect(() => {
    getWhiteLabelFromLocalStorage();
  }, [getWhiteLabelFromLocalStorage]);

  return (
    <div className="min-h-[70px] flex flex-row justify-between items-center align-items-center">
      <div>
        <LogoController
          isWhiteLabel={!!whiteLabelState?.organizationID}
          efexLogoProps={{ className: 'max-w-[150px] ml-0 mt-2' }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
      </div>
      <div>
        <LangSelector />
      </div>
    </div>
  );
};

export default Header;
